export default "__VITE_ASSET__07b379e2__"